import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Cursor = (props: SvgProps) => (
  <Svg width={13} height={14} viewBox="0 0 13 14" fill="none" {...props}>
    <g clipPath="url(#cursor_clip)">
      <path
        d="M12.1149 11.5632L11.7134 10.0625L10.9717 10.2605L10.58 8.80622L11.5102 8.55936L12.6045 7.46439L12.4013 6.70426L12.203 5.96369L11.4613 6.16166L11.2605 5.42109L10.5213 5.61906L10.3205 4.87849L9.5788 5.07647L9.38051 4.33589L8.63879 4.53631L8.4405 3.79574L7.69878 3.99372L7.50049 3.25314L6.75877 3.45112L6.56048 2.71055L5.81876 2.90852L5.62047 2.16795L4.87875 2.36592L4.68047 1.62535L3.93629 1.82577L3.73801 1.0852L2.99628 1.28317L2.798 0.542598L2.05627 0.740573L1.85799 0L1.09423 0.202863L0 1.29784L3.38306 13.9071L4.14681 13.7018L4.88854 13.5038L5.98277 12.4113L5.89464 12.0814L6.49684 11.4801L6.52621 11.4728L6.43809 11.1428L6.58007 11.001L6.8934 12.1742L7.63513 11.9763L8.0317 13.4574L8.77342 13.2594L8.97416 14L10.4772 13.5967L11.5739 12.5042L11.4833 12.1742L12.0855 11.573L12.1149 11.5632Z"
        fill="#274AE2"
      />
      <path
        d="M9.08398 12.7242L8.34226 12.9222L7.94569 11.441L7.20396 11.639L6.80495 10.1578L5.94817 11.0108L6.03385 11.3237L5.40717 11.9518L5.4953 12.2793L4.66055 13.1128L3.69361 13.3719L0.489258 1.42739L1.32156 0.596382L1.54922 0.535278L1.7475 1.27585L2.48923 1.07788L2.68751 1.81845L3.42924 1.62047L3.62752 2.36105L4.36925 2.16063L4.56753 2.9012L5.30926 2.70323L5.50754 3.4438L6.24927 3.24582L6.44755 3.9864L7.18928 3.78842L7.39001 4.52899L8.12928 4.33102L8.33002 5.07159L9.07174 4.87117L9.27003 5.61174L10.0118 5.41377L10.21 6.15434L10.9518 5.95637L11.15 6.69694L11.8918 6.49897L12.117 7.33486L11.2822 8.16587L10.0436 8.49827L10.6605 10.7958L11.4022 10.5978L11.6225 11.4166L10.9958 12.0423L11.084 12.3722L10.2517 13.2032L9.28227 13.4623L9.08398 12.7242Z"
        fill="url(#cursor_paint0)"
      />
      <path
        d="M11.4544 6.17387L11.2561 5.4333L10.5144 5.63127L10.3161 4.8907L9.57436 5.08867L9.37607 4.3481L8.63435 4.54608L8.43607 3.8055L7.69434 4.00348L7.49606 3.26291L6.75433 3.46088L6.55605 2.72031L5.81432 2.91828L5.61604 2.17771L4.87431 2.37568L4.67603 1.63511L3.9343 1.83309L3.73602 1.09251L2.99429 1.29049L2.79601 0.549917L2.05428 0.747891L1.8511 0.012207L1.10938 0.210182L4.48753 12.7999L5.22926 12.6019L5.97099 12.404L5.7727 11.6634L6.51443 11.4654L6.31615 10.7248L7.05787 10.5269L6.85959 9.7863L7.60132 9.58832L7.99788 11.0695L8.73961 10.8715L9.13618 12.3526L9.8779 12.1547L10.0762 12.8952L11.5596 12.4993L11.3614 11.7587L12.1031 11.5607L11.7065 10.0796L10.9648 10.2776L10.5682 8.79643L9.8265 8.9944L9.62821 8.25383L12.5951 7.45948L12.3968 6.71891L12.1986 5.97834L11.4568 6.17631L11.4544 6.17387Z"
        fill="url(#cursor_paint1)"
      />
      <path
        d="M1.85281 0.0115418L1.11035 0.210175L1.3088 0.949654L2.05127 0.751021L1.85281 0.0115418Z"
        fill="#274AE2"
      />
      <path
        d="M2.79223 0.556945L2.0498 0.755707L2.24888 1.49698L2.9913 1.29822L2.79223 0.556945Z"
        fill="#274AE2"
      />
      <path
        d="M3.72973 1.09711L2.9873 1.29587L3.18638 2.03714L3.9288 1.83838L3.72973 1.09711Z"
        fill="#274AE2"
      />
      <path
        d="M4.67403 1.63811L3.93164 1.83701L4.13084 2.57824L4.87323 2.37935L4.67403 1.63811Z"
        fill="#274AE2"
      />
      <path
        d="M5.61457 2.18126L4.87207 2.37976L5.07088 3.1211L5.81338 2.9226L5.61457 2.18126Z"
        fill="#274AE2"
      />
      <path
        d="M6.55304 2.72413L5.81055 2.92264L6.00936 3.66398L6.75186 3.46548L6.55304 2.72413Z"
        fill="#274AE2"
      />
      <path
        d="M7.4934 3.26428L6.75098 3.46304L6.95005 4.20432L7.69248 4.00555L7.4934 3.26428Z"
        fill="#274AE2"
      />
      <path
        d="M8.43188 3.80679L7.68945 4.00555L7.88852 4.74683L8.63095 4.54806L8.43188 3.80679Z"
        fill="#274AE2"
      />
      <path
        d="M9.37329 4.34933L8.63086 4.5481L8.82993 5.28937L9.57236 5.09061L9.37329 4.34933Z"
        fill="#274AE2"
      />
      <path
        d="M10.3137 4.89184L9.57129 5.09061L9.77036 5.83188L10.5128 5.63312L10.3137 4.89184Z"
        fill="#274AE2"
      />
      <path
        d="M11.2571 5.43592L10.5146 5.63455L10.7136 6.37586L11.4561 6.17723L11.2571 5.43592Z"
        fill="#274AE2"
      />
      <path
        d="M12.1946 5.97626L11.4521 6.1749L11.6511 6.9162L12.3936 6.71757L12.1946 5.97626Z"
        fill="#274AE2"
      />
      <path
        d="M12.3931 6.71617L8.68555 7.70807L8.88449 8.44938L12.5921 7.45748L12.3931 6.71617Z"
        fill="#274AE2"
      />
      <path
        d="M9.62625 8.25187L8.88379 8.4505L9.08273 9.19181L9.82519 8.99318L9.62625 8.25187Z"
        fill="#274AE2"
      />
      <path
        d="M7.39972 8.84733L6.65723 9.04584L6.85604 9.78718L7.59854 9.58868L7.39972 8.84733Z"
        fill="#274AE2"
      />
      <path
        d="M8.34106 9.38797L7.59863 9.58673L7.99614 11.0669L8.73857 10.8682L8.34106 9.38797Z"
        fill="#274AE2"
      />
      <path
        d="M9.47973 10.6703L8.7373 10.8691L9.13481 12.3493L9.87724 12.1505L9.47973 10.6703Z"
        fill="#274AE2"
      />
      <path
        d="M11.3614 11.7542L9.87891 12.1511L10.078 12.8924L11.5605 12.4955L11.3614 11.7542Z"
        fill="#274AE2"
      />
      <path
        d="M10.5666 8.79373L9.82422 8.99249L10.2217 10.4727L10.9642 10.2739L10.5666 8.79373Z"
        fill="#274AE2"
      />
      <path
        d="M11.7044 10.0762L10.9619 10.2747L11.3589 11.755L12.1014 11.5565L11.7044 10.0762Z"
        fill="#274AE2"
      />
      <path
        d="M6.85965 9.78449L6.11719 9.98312L6.31613 10.7244L7.05859 10.5258L6.85965 9.78449Z"
        fill="#274AE2"
      />
      <path
        d="M6.31567 10.7224L5.57324 10.9211L5.77231 11.6624L6.51474 11.4637L6.31567 10.7224Z"
        fill="#274AE2"
      />
      <path
        d="M5.77173 11.6643L5.0293 11.8631L5.22837 12.6044L5.9708 12.4056L5.77173 11.6643Z"
        fill="#274AE2"
      />
    </g>
    <defs>
      <linearGradient
        id="cursor_paint0"
        x1="6.30312"
        y1="0.535278"
        x2="0.7494"
        y2="2.14529"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="cursor_paint1"
        x1="7.21573"
        y1="3.51112"
        x2="2.63567"
        y2="8.61823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <clipPath id="cursor_clip">
        <rect width="12.6045" height="14" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default Cursor;
